import { render, staticRenderFns } from "./v2_white.vue?vue&type=template&id=3435e9a0&"
import script from "./v2_white.vue?vue&type=script&lang=js&"
export * from "./v2_white.vue?vue&type=script&lang=js&"
import style0 from "./v2_white.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports